

export default {
  SET_LOADING(state, val) {
    state.loading = val
  },

  SET_ERROR(state, err) {
    state.error = err
  },

  SET_MESSAGE(state, message) {
    state.message = message
  },

  SET_SETTINGS(state, data) {
    state.settings = data
  },
  SET_RESELLER_MARKUP(state, val) {
    state.reseller_markup = val
  },
  SET_OAUTH_URL(state, data) {
    state.oauthUrl = data
  },
  SET_AMAZON_STATE(state, data) {
    state.amazonState = data
  },
  SET_SETTINGS_LOADED(state, val) {
    state.settingsLoaded = val
  },
  SET_CONTACT(state, data) {
    state.contact = data
  },
  SET_CONTACT_LOADING(state, val) {
    state.contactLoading = val
  },
  SET_POLICY_LINKS(state, data) {
    state.policyLinks = data
  },
  SET_POLICY_LINKS_LOADING(state, val) {
    state.policyLinksLoading = val
  },
  ADD_POLICY_LINK(state, link) {
    state.policyLinks.push(link)
  },

  UPDATE_POLICY_LINK(state, updated) {
    const i = state.policyLinks.findIndex(l => l.id === updated.id)
    if (i !== -1) state.policyLinks.splice(i, 1, updated)
  },

  DELETE_POLICY_LINK(state, id) {
    state.policyLinks = state.policyLinks.filter(l => l.id !== id)
  },

  SET_BRANDING(state, data) {
    state.branding = data
    console.log('state.branding', state.branding)
  },
  SET_BRANDING_LOADING(state, val) {
    state.brandingLoading = val
  },
  SET_CHECKOUT(state, data) {
    state.checkout = data
    console.log('state.checkout', state.checkout)
  },
  SET_CHECKOUT_LOADING(state, val) {
    state.checkoutLoading = val
  },
  SET_MARKUP_LOADING(state, val) {
    state.markupLoading = val
  },
  SET_RESELLER_MARKUP(state, data) {
    state.reseller_markup = data
  },
  SET_BASIC_SETTINGS(state, data) {
    state.basicSettings = data
  }
}